import { call, put } from "@redux-saga/core/effects";
import { toast } from "react-toastify";
import { PrivilegeControllerApi } from "../../../generated/api";
import i18n from "../../../i18n/i18n";
import { getAPIConfig } from "../../../util/api-config";
import { handleError } from "../../../util/errorHandler";
import store from "../../configureStore";
import {
  GET_PRIVILEGE,
  setPrivilege,
} from "../../reducers/authorizationReducer";
import { requestPutPrivilege } from "../requests/rulesRequest";
import { setLoading } from "../../reducers/loadingReducer";

function setUpClient() {
  return new PrivilegeControllerApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleGetPrivilege(): any {
  try {
    yield put(setLoading(true));
    const RuleClient = setUpClient();
    const response = yield RuleClient.getPrivileges();
    yield put(setPrivilege(response));
  } catch (error: any) {
    yield handleError(error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* handleSavePrivilege(action: any): any {
  try {
    yield call(requestPutPrivilege, action.params);
    toast.success(String(i18n.t("toasts.importedRules")));
    yield put({ type: GET_PRIVILEGE });
  } catch (error: any) {
    yield handleError(error);
  }
}
